import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import LineAwardIcon from 'components/Luxkit/Icons/line/LineAwardIcon'
import LineCommentsAltIcon from 'components/Luxkit/Icons/line/LineCommentsAltIcon'
import LineGraphBarIcon from 'components/Luxkit/Icons/line/LineGraphBarIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const ContentContainer = styled(Group)`
  padding: ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding-top: 0;
    padding-left: ${rem(15)};
    padding-right: ${rem(15)};
  }
`

const SellingPointGrid = styled.div`
  display: grid;
  gap: ${rem(4)} ${rem(12)};
  grid-template-columns: ${rem(20)} 1fr;
  grid-template-areas:
    "icon title"
    ". description";
  align-items: center;

  > .detail-icon {
    grid-area: icon;
  }

  > .detail-title {
    grid-area: title;
  }

  > .detail-description {
    grid-area: description;
  }
`

export default function BusinessTravellerSignupBlurb() {
  return (
    <ContentContainer direction="vertical" tabletGap={48}>
      <Group direction="vertical" gap={8} tabletGap={12}>
        <Group direction="vertical">
          <Heading variant="heading2">Business travel,</Heading>
          <Heading variant="heading2alt">all in one place</Heading>
        </Group>
        <BodyText variant="medium" colour="neutral-three">
          Now it’s easier to book and manage trips for your teams on Business Traveller with our dashboard tool. It’s completely free to join—no hidden fees, no worries.
        </BodyText>
      </Group>

      <CSSBreakpoint min="tablet">
        <Group direction="vertical" tabletGap={12}>
          <SellingPointGrid>
            <LineAwardIcon className="detail-icon" size="S"/>
            <BodyText className="detail-title" variant="medium" weight="bold">
              Reduce Expenses and Reward Employees
            </BodyText>
            <BodyText className="detail-description" colour="neutral-three" variant="medium">
              Incentivise your travellers to make smart, cost-conscious decisions on work trips.
            </BodyText>
          </SellingPointGrid>

          <SellingPointGrid>
            <LineGraphBarIcon className="detail-icon" size="S"/>
            <BodyText className="detail-title" variant="medium" weight="bold">
              Insightful Reporting
            </BodyText>
            <BodyText className="detail-description" colour="neutral-three" variant="medium">
              Track expenses, monitor compliance, generate custom reports with easy-to-use reporting features - all for free!
            </BodyText>
          </SellingPointGrid>

          <SellingPointGrid>
            <LineAwardIcon className="detail-icon" size="S"/>
            <BodyText className="detail-title" variant="medium" weight="bold">Best Price Guarantee</BodyText>
            <BodyText className="detail-description" colour="neutral-three" variant="medium">
              We negotiate the best accommodation prices so you don’t have to. If you find a better price, we’ll match it.
            </BodyText>
          </SellingPointGrid>

          <SellingPointGrid>
            <LineCommentsAltIcon className="detail-icon" size="S"/>
            <BodyText className="detail-title" variant="medium" weight="bold">24/7 Customer Service</BodyText>
            <BodyText className="detail-description" variant="medium" colour="neutral-three">
              Our dedicated team is available online or on the phone anytime, whenever you need us.
            </BodyText>
          </SellingPointGrid>
        </Group>
      </CSSBreakpoint>
    </ContentContainer>
  )
}
